// Light theme disabled — button hidden
export default function ThemeToggle() {
  return null;
}
